import template from './paylocity-payroll-detail-codes.html';
import controller from './paylocity-payroll-detail-codes.controller';

let paylocityPayrollDetailCodesComponent = {
  restrict: 'E',
  template,
  controller
};

export default paylocityPayrollDetailCodesComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/paylocity/capabilities/payroll-detail-codes/paylocity-payroll-detail-codes.component.js